// extracted by mini-css-extract-plugin
module.exports = {"root":"new-password-input_root__1cpdB","tooltip":"new-password-input_tooltip__3cvtP"};